import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reading-streak-widget-full16464" }
const _hoisted_2 = { class: "reading-streak-widget-full16464__calendar" }
const _hoisted_3 = { class: "reading-streak-widget-full16464__day-label" }
const _hoisted_4 = { class: "reading-streak-widget-full16464__block" }
const _hoisted_5 = { class: "reading-streak-widget-full16464__block-text" }
const _hoisted_6 = { class: "reading-streak-widget-full16464__block" }
const _hoisted_7 = { class: "reading-streak-widget-full16464__block-text" }

import { computed } from 'vue'

import { ReadingStreakData16464 } from '@/models/interfaces'

import ReadingStreakWidget16464 from './ReadingStreakWidget16464.vue'
import ReadingStreakIcon16464 from './ReadingStreakIcon16464.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadingStreakWidgetFull16464',
  props: {
    streakData: {}
  },
  setup(__props: any) {

const props = __props

const daysOfTheWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
const currentDayIndex = new Date().getDay()

function isToday(day: string): boolean {
  return day === daysOfTheWeek[currentDayIndex]
}

const streakDays = computed(() => {
  if (props.streakData.streak_days <= 0) {
    // User has no streak.
    return []
  }

  const isCurrentDayComplete = props.streakData.remaining_seconds <= 0

  const lastStreakDay = isCurrentDayComplete
    ? currentDayIndex // Today
    : currentDayIndex - 1 // Yesterday

  const firstStreakDay = lastStreakDay - props.streakData.streak_days + 1
  const firstStreakDayThisWeek =
    firstStreakDay < 0
      ? 0 // The streak started before this week
      : firstStreakDay

  return daysOfTheWeek.slice(firstStreakDayThisWeek, lastStreakDay + 1)
})

const longestStreakText = computed(() => {
  const value = props.streakData.longest_streak_days ?? 0
  return `${value} ${value === 1 ? 'day' : 'days'}`
})

const booksReadText = computed(() => {
  const value = props.streakData.total_books_read ?? 0
  return `${value} ${value === 1 ? 'book' : 'books'}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReadingStreakWidget16464, {
      class: "reading-streak-widget-full16464__main-block",
      streakData: __props.streakData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(daysOfTheWeek, (day) => {
            return _createElementVNode("div", {
              key: day,
              class: "reading-streak-widget-full16464__day"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["reading-streak-widget-full16464__day-check", {
              'reading-streak-widget-full16464__day-check--today': isToday(day),
              'reading-streak-widget-full16464__day-check--active':
                streakDays.value.includes(day),
            }])
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "checkmark" }, null, -1)
              ]))], 2),
              _createElementVNode("p", _hoisted_3, _toDisplayString(day), 1)
            ])
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["streakData"]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "reading-streak-widget-full16464__block-title" }, "Longest streak", -1)),
      _createElementVNode("p", _hoisted_5, _toDisplayString(longestStreakText.value), 1),
      _createVNode(ReadingStreakIcon16464, {
        class: "reading-streak-widget-full16464__block-icon",
        active: true
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "reading-streak-widget-full16464__block-title" }, "Read", -1)),
      _createElementVNode("p", _hoisted_7, _toDisplayString(booksReadText.value), 1),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "reading-streak-widget-full16464__block-icon iconfont ibook" }, null, -1))
    ])
  ]))
}
}

})